import { render, staticRenderFns } from "./validate-token.vue?vue&type=template&id=330c3706&"
import script from "./validate-token.vue?vue&type=script&lang=js&"
export * from "./validate-token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports